import React, { useEffect } from "react";
import Loader from "../../components/Loader";
import { usePageTransition } from "../../services/hooks/usePageTransition";
import { useAuth } from "../../services/hooks/useAuth";
import { useRedirect } from "../../services/hooks/useRedirect";
import { useGlobal } from "../../services/hooks/useGlobal";

export default function Account() {
  const { startTransition, completeTransition } = usePageTransition();

  const { user, authStatus } = useAuth(true);

  const { redirect } = useRedirect();

  const { setPageTitle } = useGlobal();

  useEffect(() => {
    setPageTitle({
      pageTitle: `My Account`,
    });

    return () => {
      setPageTitle({
        pageTitle: null,
      });
    };
  }, []);

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  useEffect(() => {
    if (user && authStatus === "ready") {
      redirect("/account/subscriptions");
    }
  }, [user, authStatus]);

  return <Loader fixedCenter />;
}
